module.exports = __webpack_public_path__ + "img/GardenofLostCoins.6a36eadc.png";